module.exports = __webpack_public_path__ + "img/halloween_boo.6931e4a6.svg";